import styled, { css } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

const textBoldCss = ({ bold }) =>
  bold &&
  css`
    font-weight: 800;
  `

const textLightCss = ({ light }) =>
  light &&
  css`
    color: ${themeGet('colors.white')};
  `

const shouldForwardProp = prop => {
  return !['bold', 'light'].includes(String(prop))
}

export const TitleText = styled.span.withConfig({
  shouldForwardProp,
})`
  font-weight: 350;
  font-size: inherit;

  ${textLightCss}
  ${textBoldCss}
`
